import React from 'react';

import Header from './components/Header';

import { InternalNotifications } from 'modules';

import { ILayoutProps } from './Layout.types';

import './Layout.styles.scss';

const Layout = ({ children, showLogo, className = '', ...props }: ILayoutProps) => {
  return (
    <div className={`np-layout ${className}`} {...props}>
      <Header showLogo={showLogo} />

      <InternalNotifications />

      <div className="np-layout__content">{children}</div>
    </div>
  );
};

export default Layout;
